var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.templates && _vm.templateID && _vm.zones)?_c('preview-presentation',{attrs:{"templates":_vm.templates,"templateID":_vm.templateID,"locale":"es","zones":_vm.zones,"bgColor":"#FFFFFF"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }